import styles from "../../styles/_sections/_mainAttractionDetail/defineVisitors.module.scss";

const DefineVisitors = () => {
  return (
    <div className={styles.container}>
      <h2>Define Visitors</h2>

      <div className={styles.add}>
        {/* type of visitor */}
        <div className={styles.field}>
          <label>Types of visitors</label>
          <input type="text" name="typeOfVisitor" />
        </div>

        {/* price */}
        <div className={styles.field}>
          <label>Price</label>
          <input type="text" name="price" />
        </div>
        <button>+</button>
      </div>

      <ul className={styles.list}>
        <li>
          <p>Adult</p>
          <p>₪50</p>
          <span>&times;</span>
        </li>
        <li>
          <p>Children</p>
          <p>₪10</p>
          <span>&times;</span>
        </li>
        <li>
          <p>Old</p>
          <p>₪30</p>
          <span>&times;</span>
        </li>
        <li>
          <p>Adult</p>
          <p>₪50</p>
          <span>&times;</span>
        </li>
        <li>
          <p>Children</p>
          <p>₪10</p>
          <span>&times;</span>
        </li>
        <li>
          <p>Old</p>
          <p>₪30</p>
          <span>&times;</span>
        </li>
      </ul>

      <button className={styles.submitBtn}>Save</button>
    </div>
  );
};

export default DefineVisitors;
